import LengthUnit from "../units/LengthUnit";
import FunctionHelper from "./FunctionHelper";

/**
 * The UnitHelper bundles useful static functions for unit parsing and handling
 */
export default abstract class UnitHelper {
	public static ServerPPI: number = 96;

	/**
	 * Converts pixel to a unit
	 */
	public static pxToUnit(value: number, unit: LengthUnit, pointsPerInch: number, decimals?: number): number {
		let result: number = value;

		switch (unit) {
			case LengthUnit.CENTIMETER:
				result = value * 2.54 / pointsPerInch!;
				break;
			case LengthUnit.MILLIMETER:
				result = value * 25.4 / pointsPerInch!;
				break;
			case LengthUnit.POINTS:
				result = value * 72 / pointsPerInch!;
				break;
			case LengthUnit.PICA:
				result = value * 6 / pointsPerInch!;
				break;
			case LengthUnit.INCHES:
				result = value / pointsPerInch!;
				break;
		}

		let pow = Math.pow(10, !FunctionHelper.exists(decimals) ? 2 : decimals!);
		result = Math.round(result * pow) / pow;
		return result;
	}

	/**
	 * Converts a unit to pixel
	 */
	public static unitToPx(value: number, unit: LengthUnit, pointsPerInch: number): number {
		let result: number = value;

		switch (unit) {
			case LengthUnit.CENTIMETER:
				result = value / 2.54 * pointsPerInch!;
				break;
			case LengthUnit.MILLIMETER:
				result = value / 25.4 * pointsPerInch!;
				break;
			case LengthUnit.POINTS:
				result = value / 72 * pointsPerInch!;
				break;
			case LengthUnit.PICA:
				result = value / 6 * pointsPerInch!;
				break;
			case LengthUnit.INCHES:
				result = value * pointsPerInch!;
				break;
		}

		return result;
	}

	/**
	 * Converts server pixel to unit with the given unit and point per inch ratio
	 */
	public static serverPxToUnit(value: number, unit: LengthUnit, pointsPerInch: number) {
		return this.pxToUnit(value / UnitHelper.ServerPPI * pointsPerInch!, unit, pointsPerInch);
	}

	/**
	 * Converts unit to server pixel with the given unit and point per inch ratio
	 */
	public static unitToServerPx(value: number, unit: LengthUnit, pointsPerInch: number) {
		return this.unitToPx(value * UnitHelper.ServerPPI / pointsPerInch!, unit, pointsPerInch);
	}

	/**
	 * converts a unit to another unit
	 */
	public static unitToUnit(
		value: number, fromUnit: LengthUnit, toUnit: LengthUnit, pointsPerInch: number, decimals?: number
	): number {
		return this.pxToUnit(this.unitToPx(value, fromUnit, pointsPerInch), toUnit, pointsPerInch, decimals);
	}
}